// extracted by mini-css-extract-plugin
export default {"todoInput":"Form_todoInput__YnM6o","select":"Form_select__jHl8t","filterTodo":"Form_filterTodo__8CSTc"};